import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page81() {
  useEffect(() => {
    document.title = "Маяк — Страница 80"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page79" />
        <ForwardLink href="/page81" />
      </div>

      <p style={{ textAlign: "right" }}>80.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Посмотри, как ты дрожишь. Ты настолько безумен,<br/>
        что не сможешь отличить верх от низа. Как долго<br/>
        мы пробыли на этом камне? Пять<br/>
        недель? Два дня? Где мы? Помоги<br/>
        мне вспомнить, кто ты такой,<br/>
        Томми?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я, наверное, плод твоего<br/>
        воображения. Этот камень<br/>
        тоже плод твоего воображения.<br/>
        Вероятно, ты бродишь<br/>
        по ольховой роще, на севере<br/>
        Канады, как обмороженный маньяк,<br/>
        разговаривающий сам с собой, по колено<br/>
        в снегу, а метель настигает<br/>
        тебя.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Мне не помешает сигарета.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        У нас кончилась выпивка.
      </p>
      <p>Они улыбаются друг другу как старые друзья.</p>
      <br/>
      <p>ВНУТРИ. МАЯК. КОТЕЛЬНАЯ – ПОЗЖЕ</p>
      <p>МЕД КАПАЕТ в МЕДНУЮ КАНИСТРУ С КЕРОСИНОМ.</p>
      <p>
        МОЛОДОЙ, все еще одетый в пробковый жилет, капает МЕД,<br/>
        курит сигарету.
      </p>
      <p>СТАРИК наблюдает с большим любопытством.</p>
      <p>
        МОЛОДОЙ ДОСТАЕТ БАНКУ СКИПИДАРА. Тоже наливает его<br/>
        в КАНИСТРУ. Начинает размешивать куском арматуры.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Масло воров.
      </p>
      <p>МОЛОДОЙ пробует его. Ему нравится.</p>
      <p>Он наливает чашку СТАРИКУ.</p>
      <p style={{ textAlign: "right" }}>80.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page79" />
        <ForwardLink href="/page81" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710702467/the-lighthouse-script/dmwfidseyiz9etmlotmw.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page81;
